import { render } from "./ParametersSection.vue?vue&type=template&id=0e58326d&scoped=true&ts=true"
import script from "./ParametersSection.vue?vue&type=script&lang=ts"
export * from "./ParametersSection.vue?vue&type=script&lang=ts"

import "./ParametersSection.vue?vue&type=style&index=0&id=0e58326d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e58326d"]])

export default __exports__